// extracted by mini-css-extract-plugin
export default {"header":"ConnectionCard_header__poHM4","roleTitle":"ConnectionCard_roleTitle__oEarj","tags":"ConnectionCard_tags__XI6uk","content":"ConnectionCard_content__z6yHS"};